import { render, staticRenderFns } from "./ranking-foto.vue?vue&type=template&id=58b73b1d&scoped=true"
import script from "./ranking-foto.vue?vue&type=script&lang=js"
export * from "./ranking-foto.vue?vue&type=script&lang=js"
import style0 from "./ranking-foto.vue?vue&type=style&index=0&id=58b73b1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b73b1d",
  null
  
)

export default component.exports